import React from 'react';
import { motion } from 'framer-motion';
import { Badge } from '../ui/badge';
import { useLanguage } from '../../src/context/LanguageContext';

export default function MedalDisplay({ medals }) {
  const { t } = useLanguage();
  const { gold = 0, silver = 0, bronze = 0 } = medals || {};
  const total = gold + silver + bronze;

  if (total === 0) return null;

  const medalTypes = [
    { type: 'gold', count: gold, color: 'bg-gradient-to-br from-[#ffd700] to-[#b8860b] text-white border-none hover:from-[#ffd700] hover:to-[#b8860b]', label: t('medals.gold') },
    { type: 'silver', count: silver, color: 'bg-gradient-to-br from-[#c0c0c0] to-[#808080] text-white border-none hover:from-[#c0c0c0] hover:to-[#808080]', label: t('medals.silver') },
    { type: 'bronze', count: bronze, color: 'bg-gradient-to-br from-[#cd7f32] to-[#8b4513] text-white border-none hover:from-[#cd7f32] hover:to-[#8b4513]', label: t('medals.bronze') },
  ];

  return (
    <div className="flex flex-wrap gap-2 justify-center md:justify-start">
      {medalTypes.map((medal, index) => (
        medal.count > 0 && (
          <motion.div
            key={medal.type}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.1 + 0.3 }}
          >
            <Badge className={`text-sm px-3 py-1 ${medal.color}`}>
               <span className="font-bold mr-2">{medal.count}</span> {medal.label}
            </Badge>
          </motion.div>
        )
      ))}
    </div>
  );
}